// extracted by mini-css-extract-plugin
module.exports = {"full":"_3jmyFN","loader":"_1NQZQm"};